<div class="row">
	<div class="col-lg-12">
		<div class="card">
			<div class="card-header">
				<div class="row">
					<div class="col-6">
						<h1>
							<span class="badge" [ngClass]="title.class">{{title.text}}</span>
						</h1>
					</div>

				</div>
			</div>
			<div class="card-body">
				<div class="row">
					<div class="col-12">
						<input type="text" class="form-control" placeholder="Search" (keyup)="searchNgxDatatable($event,'lead_id,prospect_company,campaign_name')" />
					</div>
				</div>
				<div class="row">
					<div class="col-8">
						<app-column-selector [columns]="columns"></app-column-selector>
					</div>
					<div class="col-4" align="right" style="padding-top: 17px">
							<button class="btn btn-primary btn-sm show-btn" (click)="toogleShowInactiveCampaigns()" *ngIf="!showInactiveCampaigns">Show Inactive Campaigns</button>
							<button class="btn btn-primary btn-sm show-btn" (click)="toogleShowInactiveCampaigns()" *ngIf="showInactiveCampaigns"> Hide Inactive Campaigns</button>
					</div>
				</div>
				<div class="row">
					<div class="col-10">
						<ngx-datatable
							#tablePaid
							class="material striped"
							[rows]="pendigRescheduleLeads"
							[loadingIndicator]="loading"
							[columnMode]="columnMode.force"
							[headerHeight]="50"
							[footerHeight]="70"
							rowHeight="auto"
							[reorderable]="true"
							[scrollbarH]="true"
							[limit]="20">
							<ngx-datatable-column prop="lead_id" name="#" headerClass="title-header" [minWidth]="80" [width]="80"></ngx-datatable-column>
							<ngx-datatable-column prop="date_generated" *ngIf="showHideColumns('date_generated')" name="Appt Date" headerClass="title-header" [minWidth]="160" [width]="160">
								<ng-template let-row="row" ngx-datatable-cell-template>
									{{ row["date_generated"] | date : "short" }}
								</ng-template>
							</ngx-datatable-column>
							<ngx-datatable-column prop="primary_phone" *ngIf="showHideColumns('primary_phone')" name="Phone" headerClass="title-header" [minWidth]="150" [width]="150">
								<ng-template let-row="row" ngx-datatable-cell-template>
									{{row.primary_phone | phone }}
								</ng-template>
							</ngx-datatable-column>
							<ngx-datatable-column prop="prospect_company" *ngIf="showHideColumns('prospect_company')" name="Prospect" headerClass="title-header" [minWidth]="200" [width]="200"></ngx-datatable-column>
							<ngx-datatable-column prop="campaign_name" *ngIf="showHideColumns('campaign_name')" name="Campaign" headerClass="title-header"[minWidth]="200" [width]="200">
								<ng-template let-row="row" ngx-datatable-cell-template>
									<span class="badge clickable" [ngClass]="row['campaign_active'] == '1' ? 'bg-success' : 'bg-danger'" (dblclick)="editLead(row)">
										<i class="ri-check-line" title="Active campaign" *ngIf="row['campaign_active'] == '1'"></i>
										<i class="ri-close-line" title="Inactive campaign" *ngIf="row['campaign_active'] != '1'"></i>
										{{ row["campaign_name"] }}
									</span>
								</ng-template>
							</ngx-datatable-column>
							<ngx-datatable-column prop="change_date" name="Change Date" headerClass="title-header" [minWidth]="130" [width]="130">
								<ng-template let-row="row" ngx-datatable-cell-template>
									{{row.change_date | dateAgo }}
								</ng-template>
							</ngx-datatable-column>
							<ngx-datatable-footer>
								<ng-template class="datatable-footer" ngx-datatable-footer-template let-rowCount="rowCount"
									let-pageSize="pageSize" let-selectedCount="selectedCount" let-curPage="curPage" let-offset="offset"
									let-isVisible="isVisible">
									<strong class="footer-totals">Total Records: {{ rowCount }}</strong>
									<datatable-pager [pagerLeftArrowIcon]="'datatable-icon-left'"
												[pagerRightArrowIcon]="'datatable-icon-right'" [pagerPreviousIcon]="'datatable-icon-prev'"
												[pagerNextIcon]="'datatable-icon-skip'" [page]="curPage" [size]="pageSize" [count]="rowCount"
												[hidden]="!(rowCount / pageSize > 1)" (change)="tablePaid.onFooterPage($event)">
											</datatable-pager>
								</ng-template>
							</ngx-datatable-footer>
						</ngx-datatable>
					</div>
					<div class="col-2" style="padding-top: 92px;">
						<div class="card card-solved" (click)="getTodaySolvedReschedules()">
							<div class="card-body" align="center">
								<p class="title-card">Today Solved</p>
								<p class="number-card">{{ counts?.solved }}</p>
							</div>
						</div>
						<div class="card card-request bg-warning" (click)="getRescheduleRequests()">
							<div class="card-body" align="center">
								<p class="title-card">Requests</p>
								<p class="number-card">
									{{ counts?.requests }}
								</p>
							</div>
						</div>
						<!-- <div class="card card-news">
							<div class="card-body" align="center">
								<p class="title-card">Today New</p>
								<p class="number-card">{{ counts?.news }}</p>
							</div>
						</div> -->

						<div class="card card-pending" (click)="getPendingReschedulesLeads()">
							<div class="card-body" align="center">
								<p class="title-card">Pending</p>
								<p class="number-card">{{ counts?.pending }}</p>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</div>
